module.exports = __webpack_public_path__ + "img/5.94ba9731.png";